import { FC } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import PruRoute from 'src/app/common/components/PruRoute';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { OPM_PD_BASE_PATH, REQUEST_APPROVAL_TO_LINE_MANAGER_PATH } from '../../constants';
import BatchFilesPage from './BatchFiles/BatchFilesPage';
import PoliciesApprovalRequestPage from './PoliciesApprovalRequest/PoliciesApprovalRequestPage';

export const requestApprovalToLineManagerPath = `${OPM_PD_BASE_PATH}${REQUEST_APPROVAL_TO_LINE_MANAGER_PATH}`;

const RequestApprovalToLineManagerRoutes: FC = () => {
  return (
    <Switch>
      <Redirect exact from={requestApprovalToLineManagerPath} to={`${requestApprovalToLineManagerPath}/batch-files`} />
      <PruRoute exact path={`${requestApprovalToLineManagerPath}/batch-files`} render={() => <BatchFilesPage />} />
      <PruRoute
        exact
        path={`${requestApprovalToLineManagerPath}/batch-files/:batchId/policies-approval-request`}
        render={() => <PoliciesApprovalRequestPage />}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default RequestApprovalToLineManagerRoutes;
